import { Component } from '@angular/core';
import { CroppieOptions } from "croppie";
import { BannerPhotoComponent } from "../banner-photo/banner-photo";

@Component({
    selector: 'app-mobile-banner-photo',
    templateUrl: './mobile-banner-photo.html',
})
export class MobileBannerPhotoComponent extends BannerPhotoComponent {
    type = 'banner-mobile';
    nameFormData = 'bannerMobile'
    
    public get croppieOptions(): CroppieOptions {
        const opts: CroppieOptions = {};
        
        opts.viewport = {
            width: 536,
            height: 297,
            type: 'square'
        };
        
        opts.boundary = {
            width: 536,
            height: 297,
        };
        
        opts.enforceBoundary = true;
        opts.showZoomer = false;
        opts.enableZoom = true;
        opts.mouseWheelZoom = false;
        
        return opts;
    }
}
